import { render, staticRenderFns } from "./review-rating.vue?vue&type=template&id=08c5ea2d"
import script from "./review-rating.vue?vue&type=script&lang=ts"
export * from "./review-rating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports